var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.show)?_c('div',{staticClass:"back-to-org-domain"},[_c('a',{staticClass:"back-to-org-domain__text",attrs:{"href":_setup.destination}},[_vm._v("組織アカウント（ "+_vm._s(_setup.orgDomain)+" ）にアクセスする")]),_vm._v(" "),_c(_setup.Icon,{attrs:{"name":"next","size":"xs","color":"orange-100"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }